import Table from '../../../../../common/components/table';


export const MembershipaluesComponent = ({
    handleDelete, additionButtons, handleEdit, columnDefs, selectedMembershipValues,
}: any) => {

    return (
        <div className="w-full">
            <Table columnData={columnDefs} rowData={selectedMembershipValues}
                onEdit={handleEdit} headingName="One Membership Details"
                additionButtons={additionButtons} onDelete={handleDelete} />
        </div>
    )
}
export default MembershipaluesComponent;
